/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

interface WizardDataWrap {
    data: any;
}
export const WizardDataContext = createContext<WizardDataWrap>({ data: null });
